import React, { useState, useEffect } from "react";
import { FaCheck, FaTimes, FaInfoCircle, FaBuilding } from "react-icons/fa";
import ArenaProfile from "./arenaProfile";
import axios from "axios";

const ArenaRequests = () => {
  const [requests, setRequests] = useState([]);
  const [selectedArena, setSelectedArena] = useState(null);

  const fetchArenas = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/arenas-requests`,
        { withCredentials: true }
      );
      const data = response.data;

      const newData = data.map((item) => {
        return { ...item, status: "pending" };
      });

      setRequests(newData);
    } catch (error) {
      console.error("Error fetching arenas:", error);
    }
  };

  useEffect(() => {
    fetchArenas();
  }, []);

  const handleApprove = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/approve-arena?arenaId=${id}`,
        {},
        { withCredentials: true }
      );
      if (response.status === 200) {
        alert(response.data.message);
        fetchArenas();
      } else {
        alert(response.status + " - " + response.data.message);
      }
    } catch (error) {
      console.error("Error enabling arena:", error);
      alert(
        "Error enabling arena: " + error.response?.data?.message ||
          error.message
      );
    }
  };

  const handleDisapprove = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/disapprove-arena?arenaId=${id}`,
        {},
        { withCredentials: true }
      );
      if (response.status === 200) {
        alert(response.data.message);
        fetchArenas();
      } else {
        alert(response.status + " - " + response.data.message);
      }
    } catch (error) {
      console.error("Error enabling arena:", error);
      alert(
        "Error enabling arena: " + error.response?.data?.message ||
          error.message
      );
    }
  };

  const handleArenaClick = (arena) => {
    setSelectedArena(arena);
  };

  const handleCloseProfile = () => {
    setSelectedArena(null);
  };

  const baseBtn =
    "px-4 py-2 border-0 rounded text-white flex items-center text-[0.9rem] transition-colors duration-300";

  return (
    <div className="p-4 max-w-[1200px] mx-auto">
      <h2 className="text-[1.5rem] mb-4">Arena Registration Requests</h2>
      {requests.map((request) => (
        <div
          key={request.id}
          className="bg-[#f9f9f9] rounded-[8px] p-4 mb-4 flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-colors duration-300 hover:bg-[#f0f0f0]"
        >
          <div
            className="flex-1 cursor-pointer"
            onClick={() => handleArenaClick(request)}
          >
            <div className="flex items-center gap-2">
              <h3 className="m-0 text-[1.2rem]">{request.name}</h3>
              {request.institute && (
                <FaBuilding
                  className="text-[#3498db]"
                  title={`Associated with Institute: ${request.institute.name}`}
                />
              )}
            </div>
            <p className="my-2 text-[0.9rem]">{request.location}</p>
            <p className="m-0 text-[0.9rem]">Status: {request.status}</p>
            {request.institute && (
              <p className="m-0 text-[0.8rem] text-[#6c757d]">
                Institute: {request.institute.name} ({request.institute.institute_type_name})
              </p>
            )}
          </div>
          <div className="flex flex-col sm:flex-row gap-2 mt-4 w-full sm:w-auto sm:items-center md:mt-0">
            <button
              onClick={() => handleApprove(request.id)}
              className={`${baseBtn} bg-[#2ecc71] hover:bg-[#27ae60] md:flex-none md:justify-start flex-1 sm:flex-none sm:w-auto justify-center`}
            >
              <FaCheck className="mr-2" /> Approve
            </button>
            <button
              onClick={() => handleDisapprove(request.id)}
              className={`${baseBtn} bg-[#e74c3c] hover:bg-[#c0392b] md:flex-none md:justify-start flex-1 sm:flex-none sm:w-auto justify-center`}
            >
              <FaTimes className="mr-2" /> Disapprove
            </button>
            <button
              onClick={() => handleArenaClick(request)}
              className={`${baseBtn} bg-[#3498db] hover:bg-[#2980b9] md:flex-none md:justify-start flex-1 sm:flex-none sm:w-auto justify-center`}
            >
              <FaInfoCircle className="mr-2" /> Details
            </button>
          </div>
        </div>
      ))}
      {selectedArena && (
        <ArenaProfile arena={selectedArena} onClose={handleCloseProfile} />
      )}
    </div>
  );
};

export default ArenaRequests;
